import React, { useState } from "react";
// 12 Jun 2025
import { useGetUserActionsQuery } from '@/features/userActions/userActionsApiSlice'
import { useGetTrailsQuery } from '@/features/trails/trailsApiSlice'

import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon 
} from "@heroicons/react/24/solid"

import EtActionCard from '@/components/actions/EtActionCard'
import moment from "moment";

const EtTrinityReviewCompletedActions = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Display user's pending actions to help them clear backlog
  // Updated - 21 Jun 2025 - Added the main logic using EtActionCard

  // 1a-  State variables
  const [selectedTrail, setSelectedTrail] = useState("all");
  const [selectedTimeChip, setSelectedTimeChip] = useState("today");// 21 Jun 2025

  // 1b - Time boundaries - 21 Jun 2025
  // const now = moment();
  // const startOfToday = moment().startOf("day");
  // const startOfWeek = moment().startOf("week");
  // const startOfMonth = moment().startOf("month");
  // const startOfQuarter = moment().startOf("quarter");
  // const startOfYear = moment().startOf("year");

  // 22 Jun 2025
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  // const startOfWeek = moment().startOf("week"); // Monday 00:00
  const startOfWeek = moment().isoWeekday(1).startOf("day"); // Monday of current week
  const endOfWeek = endOfToday; // ✅ Cap at today to avoid future meetings

  const startOfMonth = moment().startOf("month"); // 1st of month
  const endOfMonth = moment().isSame(now, 'month') ? endOfToday : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, 'quarter') ? endOfToday : moment().endOf("quarter");

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, 'year') ? endOfToday : moment().endOf("year");
  
  // 2a - Fetch Data
  const { data: userActionsData, refetch: refetchUserActions } = useGetUserActionsQuery();
  const { data: trailsData } = useGetTrailsQuery();

  // 2️b -  Extract Data
  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  const allActions = extractEntitiesFromAdapter(userActionsData);
  const allTrails = extractEntitiesFromAdapter(trailsData);

  console.log('allActions', allActions)
  console.log('allTrails', allTrails)

  // 3️⃣ Filter completed actions
  const completedActions = allActions?.filter(action =>
    action?.userId?._id === userId &&
    action?.userActionProgress === 100
  );

  // 3b️ Time Chip Filter
  const timeFilteredActions = completedActions?.filter(action => {
    const completedDate = moment(action.updatedAt || action.completedAt || action.completeBy);
    switch (selectedTimeChip) {
      case "today":
        return completedDate.isSame(startOfToday, "day");
      case "week":
        return completedDate.isSameOrAfter(startOfWeek);
      case "month":
        return completedDate.isSameOrAfter(startOfMonth);
      case "quarter":
        return completedDate.isSameOrAfter(startOfQuarter);
      case "year":
        return completedDate.isSameOrAfter(startOfYear);
      default:
        return true;
    }
  });

  const usedTrailNames = Array.from(new Set(timeFilteredActions?.map(a => a?.trailId?.trailName)));
;

  const filteredActions = selectedTrail === "all"
  ? timeFilteredActions
  : timeFilteredActions?.filter(a => a?.trailId?.trailName === selectedTrail);

  return (
    <div className="p-4 w-full max-w-6xl mx-auto">
      <div className="flex justify-between items-center">
           <p className="text-lg font-bold text-gray-800 mb-2">Your Completed Actions 🎉</p>
           {/* Close */}
          <button onClick={onClose} className="mx-2 px-2 mb-2 text-sm text-blue-600 underline">
            Close
          </button>
      </div>
    
      {/* Trail Filter */}
      <div className="m-1 p-1">
      <div className="my-2 py-2 flex justify-center items-center space-x-2 border-b border-t bg-orange-50">
        <div className="flex items-center">
          <ArrowTrendingUpIcon className="w-6 h-6 text-orange-600" />
          <p className="mx-1 px-1 text-lg font-bold text-orange-600">Trail:</p>
          <select
            value={selectedTrail}
            onChange={(e) => setSelectedTrail(e.target.value)}
            className="text-lg font-bold rounded border border-gray-300 px-2 py-1"
          >
            <option value="all">All Trails</option>
            {allTrails
              ?.filter(trail => usedTrailNames.includes(trail.trailName))
              ?.map(trail => (
                <option key={trail._id} value={trail.trailName}>
                  {trail.trailName}
                </option>
            ))}
          </select>
        </div>

        {/* Action Count Badge */}
        <div className="flex justify-center items-center">
          <span className="text-lg text-gray-700 mx-1 px-1">You completed </span>
          <div className="w-8 h-8 rounded-full bg-orange-600 text-white flex justify-center items-center text-lg font-bold">
            {filteredActions?.length || 0}
          </div>
          {/* <span className="text-lg text-gray-700 mx-1 px-1">actions {selectedTimeChip} 🎉! </span> */}
          <span className="text-lg text-gray-700 mx-1 px-1">
            actions{" "}
            {selectedTimeChip === "today"
              ? "today"
              : selectedTimeChip === "week"
              ? "this week"
              : selectedTimeChip === "month"
              ? "this month"
              : selectedTimeChip === "quarter"
              ? "this quarter"
              : "this year"} 🎉!
          </span>

        </div>
      </div>
      </div>

      {/* Time Chips */}
      <div className="flex justify-center items-center gap-2 my-3">
        {["today", "week", "month", "quarter", "year"].map(chip => (
          <button
            key={chip}
            onClick={() => setSelectedTimeChip(chip)}
            className={`px-3 py-1 text-sm font-semibold rounded-full border ${
              selectedTimeChip === chip
                ? "bg-orange-600 text-white border-orange-600"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {chip === "today" ? "Today" :
            chip === "week" ? "This Week" :
            chip === "month" ? "This Month" :
            chip === "quarter" ? "This Quarter" :
            "This Year"}
          </button>
        ))}
      </div>



      {/* Action List */}
      <div className="max-h-[400px] overflow-y-auto ">
        {filteredActions?.length > 0 ? (
          filteredActions
            ?.slice()
            ?.sort((a, b) => new Date(a.completeBy) - new Date(b.completeBy))
            ?.map((action, index) => (
              <EtActionCard
                key={action._id}
                action={action}
                actionIndex={index}
                refetchUserActions={refetchUserActions}
                showEdit={false}
              />
            ))
        ) : (
          <p className="text-sm italic text-gray-500 mt-4">
            No completed actions found for today.
          </p>
        )}
      </div>

      
    </div>
  );
};

export default EtTrinityReviewCompletedActions;